export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/hash.worker.1e5c2639.worker.js");
}
